import { Box, Stack } from "@mui/material";

import Application from "../../../components/application";
import MyPanel from "../../../components/myPanel";
import MyLabel from "../../../components/myLabel";
import MyInput from "../../../components/myInput";
import MyButton from "../../../components/myButton";
import { useNavigate, useParams } from "react-router-dom";
import useVideoState from "../../../hooks/useVideoState";
import { useContext, useEffect } from "react";
import MyLoading from "../../../components/myLoading";
import MyYoutube from "../../../components/myYoutube";
import TELAS from "../../../constants/telas";
import { AuthContext } from "../../../contexts/auth";
import TELA_ACOES from "../../../constants/telaAcoes";
import permissaoTelas from "../../../utils/permissaoTelas";

const PAGINA = {
    aplicacao: 'SisPalo - Colaborador',
    funcionalidade: 'Cursos',
    tela: TELAS.CURSOS,
    acoes: [TELA_ACOES.Alterar]
}

const Video = () => {
    const navigate = useNavigate()
    const { id, idCurso } = useParams()
    
    const states = useVideoState()
    const {permissaoUsuario} = useContext(AuthContext); /* permissão para telas*/    

    useEffect(()=>{
        /* permissão para telas*/
        if (permissaoTelas(permissaoUsuario, TELA_ACOES.Alterar , PAGINA)){
            states.cursos.set(idCurso)
            if (id && id !== ''){
               states.submit.set(id)
            }
        }
        else {
            navigate('/gestor/dashboard')
        }
    }, [])

    
    return (
  
        <Application>
            <MyPanel>
                <MyLoading render={states.submit.value}/>
                <Box sx={{display: 'flex'}}>
                    <Stack spacing={5} sx={{display: 'flex', width:'100%'}}>
                        <MyLabel component='h1' text={`Video: ${states.nome.value}`}/>
                        <Box>
                            <Stack spacing={2}>
                                <MyInput sx={{width:'100%'}} size="small" label='Nome' type='text' value={states.nome.value} onChange={(e)=>states.nome.set(e.target.value)}/>
                                <MyInput sx={{width:'100%'}} size="small" label='Número sequência exibição' type='number' value={states.sequencia.value} onChange={(e)=>states.sequencia.set(e.target.value)}/>
                                <MyInput sx={{width:'100%'}} size="small" label='ID do video' type='text' value={states.linkvideo.value} onChange={(e)=>states.linkvideo.set(e.target.value)}/>
                                <MyInput sx={{width:'100%'}} size="small" label='Descrição' type='text' value={states.descricao.value} onChange={(e)=>states.descricao.set(e.target.value)}/>
                                <Box sx={{display:'flex', marginTop: 2 , justifyContent:'space-between'}}>
                                    <MyButton color='warning' onClick={()=> navigate(`/gestor/curso/${idCurso}/videos`)} variant='contained' text='Cancelar'/>
                                    <MyButton sx={{marginRight:1}} color='success' onClick={()=> states.video.value ? states.videoPut.set(id) : states.videoPost.set()} variant='contained' text={states.video.value ? 'Alterar' : 'Salvar'} />
                                </Box>
                            </Stack>
                        </Box>
                    </Stack>
                    <Box sx={{display: 'flex', marginLeft:5}}>
                        <MyYoutube embedId={states.linkvideo.value} width='400' height='350' title={states.nome.value}/>
                    </Box>
                </Box>
            </MyPanel>
        </Application>
   
    )
}

export default Video;